import { type ExtendedAuthState, initialAuthState } from './slices/auth/initial-state';
import { type CommonState, initialCommonState } from './slices/common/initial-state';
import { initialSettingsState, type UserSettingsState } from './slices/settings/initial-state';

export type UserState = UserSettingsState & ExtendedAuthState & CommonState;

export const initialState: UserState = {
  ...initialSettingsState,
  ...initialAuthState,
  ...initialCommonState,
};
